module.exports = __webpack_public_path__ + "eae14093493549ad60649d43af21825c.svg";